<template>
    <div class="toolsActivityEdit bgc box-shadow">
        <div class="topText"><i class="el-icon-warning"></i>请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，我们保有依据国家规定及平台规则进行处理的权利。</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <!--基本信息-->
            <div class="activityMsgBox">
                <div class="title"><p>基本信息</p></div>
                <div class="contentBox">
                    <div class="left">
                        <el-form-item label="机构名称" prop="orgname">
                            <el-input v-model="ruleForm.orgname" maxlength="12" show-word-limit placeholder="请输入机构名称(不超过12个字)"></el-input>
                        </el-form-item>
                        <el-form-item label="机构logo" required class="posterImg" prop="qrcodeatturlid">
                            <div class="imgBoxCode mechLogo">
                                <i class="el-icon-picture" v-if="!ruleForm.logourl"></i>
                                <img class="activityCoverImage" :src="ruleForm.logourl.furl + '?' + time" v-else-if="ruleForm.logourl && ruleForm.logourl.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <UploadFile :uploadType="uploadVideoType" @setFile="setLogoFile" :fileRule="fileRule" ></UploadFile>
                                <p>建议尺寸180*180px，JPG、PNG格式， 图片小于5M。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="机构封面图" class="posterImg">
                            <div class="imgBoxCode mechImg">
                                <i class="el-icon-picture" v-if="!ruleForm.bannerlogourl"></i>
                                <img class="activityCoverImage" :src="ruleForm.bannerlogourl.furl + '?' + time" v-else-if="ruleForm.bannerlogourl && ruleForm.bannerlogourl.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox" style="width: 360px">
                                <UploadFile :uploadType="uploadVideoType" @setFile="setBannerFile" :fileRule="fileRule" ></UploadFile>
                                <p>建议尺寸1200*240px，JPG、PNG格式， 图片小于5M。 机构封面图作为背景使用，尽量使用简洁的图片。</p>
                            </div>
                        </el-form-item>
                        <el-form-item label="机构简介">
                            <el-input type="textarea" v-model="ruleForm.orgmemo" maxlength="80"  show-word-limit placeholder="请输入机构简介(不超过80个字)"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <!--客服信息-->
            <div class="serviceSet payVoucherMsgBox">
                <div class="title"><p>客服信息</p></div>
                <div class="contentBox">
                    <div style="margin-top: 20px">
                        <el-form-item label="客服二维码" required class="posterImg" prop="qrcodeatturlid">
                            <div class="imgBoxCode">
                                <i class="el-icon-picture" v-if="!ruleForm.serviceqrurl"></i>
                                <img class="activityCoverImage" :src="ruleForm.serviceqrurl.furl + '?' + time" v-else-if="ruleForm.serviceqrurl && ruleForm.serviceqrurl.furl + '?' + time" alt="">
                            </div>
                            <div class="uploadFileBox">
                                <UploadFile :uploadType="uploadVideoType" @setFile="setServiceFile" :fileRule="fileRule" ></UploadFile>
                                <p>建议尺寸120*120px，JPG、PNG格式，图片小于100KB</p>
                            </div>
                        </el-form-item>
                        <!--<el-form-item label="客服名称" prop="servicedesp">-->
                            <!--<el-input v-model="ruleForm.servicempno" placeholder="建议不超过6个字"></el-input>-->
                        <!--</el-form-item>-->
                        <el-form-item label="联系电话" prop="linktel">
                            <el-input v-model="ruleForm.linktel" maxlength="20" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                        <el-form-item label="联系邮箱">
                            <el-input v-model="ruleForm.linkemail" maxlength="20" placeholder="请输入联系邮箱"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <!--机构详情-->
            <div class="activityMsgBox">
                <div class="title"><p>机构详情</p></div>
                <div class="contentBox">
                    <el-form-item label="关于我们">
                        <uEditor :content="ruleForm.orgdesp" ref="uEditor1" @getUEditorContent="getTrySeeContent"></uEditor>
                    </el-form-item>
                </div>
            </div>
            <el-form-item class="btnBox">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="submitForm(ruleForm)">提交</el-button>
            </el-form-item>
        </el-form>
        <shopDistribution ref="shop"></shopDistribution>
    </div>
</template>
<script>
    import UploadFile from 'base/upload/uploadFile2'
    import UEditor from 'base/uEditor/uEditor2'
    import shopDistribution from 'base/uEditor/dataComponents/shopDistribution.vue'
    import {mapGetters, mapActions} from 'vuex'
    import {computeFileSize} from 'common/js/tools'
    import {getHostDetail, updateHostinfo} from 'api/curriculumApi'
    import {findAllMpaccount} from 'api/accountApi'
    import ShopLocalCropper from 'base/cropper/shopLocalCropper'
    import { format } from 'path'
    export default {
        name: 'mechanismEdit',
        data() {
            return {
                time:'',
                ruleForm:{},
                uploadVideoType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                uploadType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                fileRule: {
                    btnName: '选择文件',
                    cls: '',
                    accept: '.jpg,.jpeg,.png',
                    size: 2,
                    width: '750',
                    height: '420'
                },
                rules: {
                    orgname: [
                        {required: true, message: '请输入机构名称', trigger: 'blur'},
                        {max: '12', message: '不超过12字',  trigger: 'blur'}
                    ],
                    linktel: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'},
                    ],
                }
            }
        },
        created() {
        },
        mounted() {
            this._getInfo();
        },
        methods: {
            // 获取机构详情
            _getInfo(){
                getHostDetail({
                    success: data => {
                        console.log(data);
                        this.ruleForm=data.data;
                        this.$refs.uEditor1.init(this.ruleForm.orgdesp)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },
            // uEditor内容展示
            getTrySeeContent(content) {
                this.ruleForm.orgdesp = content
            },
            // 编辑机构
            submitForm(data){
                let logourl = JSON.stringify(this.ruleForm.logourl),
                    bannerlogourl = JSON.stringify(this.ruleForm.bannerlogourl),
                    serviceqrurl = JSON.stringify(this.ruleForm.serviceqrurl);
                let params= {
                    orgname:data.orgname,
                    logourl:logourl,
                    bannerlogourl:bannerlogourl,
                    orgmemo:data.orgmemo,
                    orgdesp:data.orgdesp,
                    serviceqrurl:serviceqrurl,
                    linktel:data.linktel,
                    linkemail:data.linkemail,
                };
                updateHostinfo({
                    data: params,
                    success: data => {
                        console.log(data);
                        this.$message({type: 'success', message: '操作成功！'});
                        this.$router.push({name: 'CurriculumList'})
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    }
                })
            },

            cancel() {
                this.$router.go(-1)
            },
            setFile(file) {
                computeFileSize()
                this.ruleForm.coveratturlid = file
                this.time = new Date().getTime()
            },
            setLogoFile(file) {
                computeFileSize()
                delete file.type;
                this.ruleForm.logourl = file;
                this.time = new Date().getTime()
            },
            setServiceFile(file) {
                delete file.type;
                computeFileSize()
                this.ruleForm.serviceqrurl = file;
                this.time = new Date().getTime()
            },
            setBannerFile(file) {
                computeFileSize()
                delete file.type;
                this.ruleForm.bannerlogourl = file;
                this.time = new Date().getTime()
            },
            ...mapActions([
                'setLoading'
            ])
        },
        watch: {
        },
        components: {
            UploadFile, UEditor, shopDistribution, ShopLocalCropper
        }
    }
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss" scpoed>
    @import "~common/scss/variable";
    @import "~common/scss/mixin";
    .toolsActivityEdit{
        background: #fff;
        min-width: 1200px;
        .topText{
            width:100%;
            height:44px;
            line-height: 44px;
            background:rgba(253,246,236,1);
            border-radius:4px;
            color: #E6A23C;
            .el-icon-warning{
                padding-left: 20px;
                padding-right: 10px;
            }
        }
        .title{
            padding-bottom: 8px;
            p{
                border-left: 2px solid #409EFF;
                text-indent: 8px;
                font-size: 16px;
                font-weight: 500;
            }
        }
        .shareTitle{
            border: none;
        }
        .el-form{
            .el-form-item {
                .el-form-item__label{
                    text-align: left;
                    font-size: 14px;
                }
            }
            .inputTips{
                color: #C0C4CC;
                margin-left: 10px;
            }
            .imgBoxCode {
                float: left;
                margin-right: 30px;
                width: 120px;
                height: 120px;
                font-size: 64px;
                text-align: center;
                line-height: 120px;
                color: #DCDFE6;
                background: #F5F7FA;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .uploadFileBox {
                float: left;
                margin-top: 25px;
            }
        }
        .activityMsgBox{
            .left{
                min-width: 850px;
                .mechLogo{
                    width: 110px;
                    height: 110px;
                }
                .mechImg{
                    width: 218px;
                    height: 128px;
                }
            }
        }
        .shareSet{
            .contentBox{
                display: block !important;
                .shareImg{
                    .el-form-item__content{
                        display: flex;
                        align-items: center;
                        .imgBoxCode{
                            width: 178px;
                            height: 178px;
                            background: #F5F7FA;
                            text-align: center;
                            line-height: 178px;
                            .el-icon-picture{
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityShareImage{
                                width: 178px;
                                height: 178px;
                            }
                        }
                        .uploadFileBox{
                            margin-left: 12px;
                            .uploadFile{
                                .el-upload{
                                    .el-button{
                                        background: #fff;
                                        border-color: #C0C4CC;
                                        span{
                                            color: #000;
                                        }
                                    }
                                }
                            }
                            p{
                                color: #909399;
                            }
                        }
                    }
                }
                .el-textarea{
                    width: 400px;
                    .el-textarea__inner{
                        width: 400px;
                    }
                }
            }
        }
        .activityMsgBox, .posterSetBox{
            background: #fff;
            padding: 20px;
            .contentBox{
                padding-top: 20px;
                display: flex;
                // justify-content: space-between;
                .left{
                    .cover,.posterImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .imgBox{
                                width: 318px;
                                height: 178px;
                                background: #F5F7FA;
                                text-align: center;
                                line-height: 178px;
                                .el-icon-picture{
                                    color: #DCDFE6;
                                    font-size: 40px;
                                }
                                .activityCoverImage{
                                    width: 318px;
                                    height: 178px;
                                }
                            }
                            .uploadFileBox{
                                margin-left: 12px;
                                .uploadFile{
                                    .upload-demo{
                                        .el-upload {
                                            .el-button{
                                                background: #fff;
                                                color: #000;
                                                border: 1px solid #C0C4CC;
                                            }
                                        }
                                    }
                                }
                                p{
                                    color: #909399;
                                    font-size: 14px;
                                    line-height: 20px;
                                }
                            }
                        }
                    }
                    .el-form-item{
                        .el-form-item__content{
                            .el-input{
                                width: 100%;
                            }
                            .el-date-editor{
                                .el-input__icon, .el-range-separator{
                                    line-height: 25px;
                                }
                            }
                            .mostTips{
                                color: #C0C4CC;
                            }
                            .showRankingListTips{
                                color: #909399;
                                margin-left: 20px;
                                position: relative;
                                top: 2px;
                            }
                        }
                    }
                    .date{
                        .el-form-item__label::after{
                            content: '*';
                            color: #F56C6C;
                            margin-left: 4px;
                        }
                        .el-form-item__content{
                            width: 500px;
                            .to{
                                margin: 0 13px;
                            }
                            .el-date-editor {
                                width: 180px;
                                .el-input__inner{
                                    padding-right: 0;
                                }
                            }
                        }
                    }
                }
                .right{
                    width: 300px;
                    height: 534px;
                    background:rgba(242,246,252,1);
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                    overflow: hidden;
                    margin-left: 30px;
                    .innerBox{
                        width: 320px;
                        height: 482px;
                        overflow-y: scroll;
                    }
                    .topBox{
                        height: 52px;
                        .top{
                            width: 300px;
                            height: 52px;
                        }
                    }
                    .coverImgBox{
                        background: #DCDCDC;
                        width: 300px;
                        height: 168px;
                        .activityCoverImage{
                            width: 300px;
                            height: 168px;
                        }
                    }
                    .priceBox{
                        height: 60px;
                        background: #fff;
                        border-bottom: 1px solid #f5f5f5;
                        padding: 7px 12px;
                        box-sizing: border-box;
                        .price{
                            color: #F56C6C;
                            margin-top: 5px;
                        }
                        .outofprint{
                            color: #909399;
                            margin-top: 10px;
                        }
                    }
                    .rightTitleBox{
                        // height: 60px;
                        background: #fff;
                        padding: 7px 12px;
                        box-sizing: border-box;
                        .rightTitle{
                            margin-top: 5px;
                        }
                        .rightSubtitle{
                            color: #909399;
                            margin-top: 10px;
                        }
                    }
                    .detailsBox{
                        margin-top: 10px;
                        .detailsTitle{
                            background: #fff;
                            padding-left: 12px;
                            height: 40px;
                            line-height: 40px;
                            border-bottom: 1px solid #f5f5f5;
                        }
                        .detailsContent{
                            background: #fff;
                            padding: 12px;
                            p{
                                line-height: 15px;
                            }
                            img{
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }
        .distributionMsgBox{
            background: #fff;
            padding: 20px;
            margin-bottom: 24px;
            .contentBox{
                margin-top: 20px;
                .earnings{
                    .el-form-item__content{
                        margin-left: 0 !important;
                        .one{
                            margin-bottom: 15px;
                        }
                        .el-form-item{
                            .el-form-item__content{
                                .el-input {
                                    margin-top: 5px;
                                }
                                .el-form-item__error{
                                    left: 120px;
                                }
                            }
                        }
                    }
                }
                .el-form-item{
                    .el-form-item__content{
                        .el-input{
                            width: 400px;
                        }
                        .bindclienttypeTips{
                            color: #909399;
                            line-height: 20px;
                        }
                    }
                }
                .distributionGrade{
                    .el-form-item__content{
                        .el-input-number{
                            width: 100px;
                            line-height: 32px;
                            .el-input-number__decrease,.el-input-number__increase{
                                width: 30px;
                                height: 30px;
                                border: none;
                                background: #409EFF;
                                color: #fff;
                            }
                            .el-input{
                                width: 100px;
                                .el-input__inner{
                                    padding: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
        .payVoucherMsgBox{
            background: #fff;
            padding: 20px;
            .contentBox{
                display: flex;
                // justify-content: space-between;
                .left{
                    // width: 970px;
                    .el-form-item__content{
                        margin-left: 10px !important;
                        .el-radio-group{
                            padding-top: 20px;
                            .noCondition{
                                // height: 32px;
                            }
                            .cdkey{
                                margin-top: 10px;
                                .uploadXlsBox{
                                    .uploadXlsTips{
                                        margin-top: 10px;
                                    }
                                }
                            }
                        }
                        .el-radio{
                            width: 90px;
                        }
                        .noCondition{
                            .tips{
                                color: #C0C4CC;
                            }
                        }
                        .buyDistribution{
                            margin-top: 10px;
                            .el-input{
                                width: 520px;
                            }
                        }
                        .cdkey{
                            display: flex;
                            margin-top: 10px;
                            min-height: 40px;
                            .el-radio{
                                position: relative;
                                top: 5px;
                            }
                            .uploadXlsBox{
                                .actionBox{
                                    display: flex;
                                    .uploadFile{
                                        .upload-demo{
                                            .el-upload {
                                                .el-button {
                                                    background: #67C23A;
                                                    border: 1px solid #67C23A;
                                                }
                                            }
                                        }
                                    }
                                    .download{
                                        margin-left: 34px;
                                        color: #409EFF;
                                        cursor: pointer;
                                        border: none;
                                    }
                                    .download:hover {
                                        background: #fff
                                    }
                                }
                                .uploadXlsTips{
                                    color: #C0C4CC;
                                    font-size: 12px;
                                }
                            }
                        }
                        .code{
                            margin-top: 10px;
                            display: flex;
                            align-items: center;
                            .codeTips{
                                width: 400px;
                                background: #F56C6C;
                                line-height: 32px;
                                color: #fff;
                                border-radius:4px;
                                text-indent: 26px;
                                font-size: 14px;
                            }
                        }
                        .selfContent{
                            margin-top: 20px;
                        }
                    }
                }
                .right{
                    margin-top: 50px;
                    width: 300px;
                    height: 534px;
                    background: #F2F6FC;
                    box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
                    margin-left: 130px;
                    .topBox{
                        width: 300px;
                        height: 52px;
                        position: relative;
                        .top{
                            width: 300px;
                            height: 52px;
                        }
                        .tips{
                            position: absolute;
                            width: 224px;
                            bottom: 10px;
                            text-align: center;
                            left: 40px;
                            font-weight: 500;
                        }
                    }
                    .tipsContentBox{
                        width: 300px;
                        height: 482px;
                        overflow: hidden;
                        .innerBox{
                            width: 320px;
                            height: 482px;
                            overflow-y: scroll;
                        }
                        .successTips{
                            width: 300px;
                            height: 104px;
                        }
                        .redeemCodeTips{
                            width: 300px;
                            height: 40px;
                        }
                        .destroyTips{
                            width: 300px;
                            height: 105px;
                        }
                        .codeTips{
                            width: 300px;
                            height: 150px;
                        }
                        .selfContent{
                            padding: 16px 12px;
                            background: #fff;
                            line-height: 20px;
                        }
                    }
                }
            }

        }
        .posterSetBox{
            background: #fff;
            .contentBox{
                .left{
                    width: 801px;
                    .el-form-item{
                        .el-switch{
                            margin-right: 30px;
                        }
                    }
                    .imgBoxPoster{
                        width: 178px;
                        height: 317px;
                        background: #F5F7FA;
                        text-align: center;
                        line-height: 317px;
                        .el-icon-picture{
                            color: #DCDFE6;
                            font-size: 40px;
                        }
                        .activityCoverImagePoster{
                            width: 178px;
                            height: 317px;
                        }
                    }
                    .inviteImg{
                        .el-form-item__content{
                            display: flex;
                            align-items: center;
                            .el-color-picker {
                                width: 16px;
                                height: 16px;
                                margin-right: 28px;
                                .el-color-picker__trigger{
                                    padding: 0;
                                    width: 16px;
                                    height: 16px;
                                }
                            }
                            .el-slider{
                                width: 160px;
                                display: inline-block;
                            }
                        }
                    }
                    .serviceSet{
                        .title{
                            border-bottom: none;
                        }
                        .imgBoxCode{
                            width: 178px;
                            background: #F5F7FA;
                            text-align: center;
                            line-height: 178px;
                            height: 178px;
                            .el-icon-picture{
                                color: #DCDFE6;
                                font-size: 40px;
                            }
                            .activityCoverImage{
                                width: 178px;
                                height: 178px;
                            }
                        }
                    }
                }
                .right{
                    margin-left: 30px;
                    position: relative;
                    .posterBg{
                        width: 300px;
                        height: 534px;
                    }
                    .headImg{
                        width: 48px;
                        height: 48px;
                        background: #D8D8D8;
                        border: 1px solid #979797;
                        text-align: center;
                        line-height: 48px;
                        position: absolute;
                        cursor: move;
                    }
                    .side{
                        border-radius: 0;
                    }
                    .circle{
                        border-radius: 50%;
                    }
                    .nickname{
                        position: absolute;
                        cursor: move;
                    }
                    .rightCodeBox{
                        cursor: move;
                        position: absolute;
                        .cover{
                            width: 80px;
                            height: 80px;
                            position: absolute;
                        }
                        img{
                            width: 80px;
                            height: 80px;
                        }
                    }
                }
            }
        }
        .el-radio__input.is-checked+.el-radio__label{
            color: #303133;
        }
        .btnBox{
            .el-form-item__content{
                margin-left: 0 !important;
                padding-left: 121px;
                background: #fff;
                height: 80px;
                line-height: 80px;
            }
        }
        .textareaSet {
            width: 400px;
            height: 117px;
            textarea {
                width: 100%;
                height: 100%;
            }
        }
    }
    /*文本框样式*/
    .el-textarea__inner{
        padding: 5px 40px 5px 15px;
    }
    /*星号显示在右侧*/
    .el-form-item {
        .el-form-item__label {
            text-align: left
        }
        &.is-required {
            .el-form-item__label::after{
                content: "*";
                color: #F56C6C;
                margin-left: 4px;
            }
            .el-form-item__label::before {
                display: none;
            }
        }
    }
</style>
